import { APIContext } from "../../types";
import { makePath } from "../../../../api/url";

export type DetectedMarkingsAPI = ReturnType<typeof createDetectedMarkingsAPI>;

export function createDetectedMarkingsAPI({ buildURL, fetchJSON }: APIContext) {
  return {
    getCount({
      patientId,
      scanId,
      scanVersion,
    }: {
      patientId: string;
      scanId: string;
      scanVersion: string;
    }) {
      const path = makePath([
        "api",
        "v1",
        "patient",
        patientId,
        "scan",
        scanId,
        "version",
        scanVersion,
        "detected-markings",
      ]);

      const url = buildURL(path);
      const request = new Request(url.toString());
      return fetchJSON<number>(request);
    },
  };
}
